import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":"","fill-height":""}},[_c(VLayout,{attrs:{"justify-center":"","align-center":""}},[_c('h1',{domProps:{"textContent":_vm._s(_vm.$t('msg.home'))}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }